
import React from 'react';
import PopUpOneLine from '../PopUpOneLine';



const Kopon_Rejected = (props) => {

    return (
        <PopUpOneLine
            cssStyl={"specialPopComp onTopOfAll noPadding"}
            key={"popKoponRejected"}
            topTitle={"הקופון אינו זמין"}
            Title={[
                "לא ניתן להפעיל את הקופון על ההזמנה.",
                "תוכל להמשיך בתשלום על הסכום המלא,",
                "או לבטל ולחזור להזמנה."
            ]}
            inLabel={""}
            closeFunc={() => props.closePop()}
            btn1Clck={() => { props.okClick() }}
            btn1Txt={"המשך בסכום המלא"}
            btn2Txt={"ביטול, חזרה להזמנה"}
            btn2Clck={() => { props.closePop() }}
        />
    )
}


export default Kopon_Rejected
